export const STANDARD_PAGE_FETCH_REQUESTED = 'STANDARD_PAGE_FETCH_REQUESTED';
export const STANDARD_PAGE_FETCH_SUCCEEDED = 'STANDARD_PAGE_FETCH_SUCCEEDED';
export const STANDARD_PAGE_FETCH_FAILED = 'STANDARD_PAGE_FETCH_FAILED';
